module.exports = __webpack_public_path__ + "static/img/home.656e0a7e.svg";